import Party from './Party'
import PartyResult from './PartyResult'
import PartyResultMap from './PartyResultMap'

export default class AbstractResult {
  protected _totalVoteCount: number = 0
  protected _totalSeatCount: number = 0
  protected _partyResultMap: PartyResultMap

  public get totalVoteCount(): number {
    return this._totalVoteCount
  }

  public get totalSeatCount(): number {
    return this._totalSeatCount
  }

  public get partyResultMap(): PartyResultMap {
    return this._partyResultMap.clone()
  }

  public constructor() {
    this._partyResultMap = new PartyResultMap()
  }

  protected calculatePartyResults(): void {
    throw new Error(
      'Unimplemented abstract method AbstractResult.calculatePartyResults!'
    )
  }

  public winner(): PartyResult {
    return this.nthPlace(1)
  }

  public nthPlace(n: number): PartyResult {
    return this._partyResultMap.resultsBySeatCount()[n - 1]
  }

  public margin(): number {
    return this.winner().votePercent - this.nthPlace(2).votePercent
  }

  public partyResultByParty(party: Party): PartyResult | undefined {
    return this.partyResultByPartyKey(party.key)
  }

  public partyResultByPartyKey(key: string): PartyResult | undefined {
    return this._partyResultMap.resultForPartyKey(key)
  }
}
